"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.InteractionType=void 0;var c;(function(e){e.Check="Check",e.Click="Click",e.Collapse="Collapse",e.Expand="Expand",e.Save="Save",e.Uncheck="Uncheck"})(c||(exports.InteractionType=c={}));
//# sourceMappingURL=InteractionType.js.map
